import { Controller } from '@hotwired/stimulus';
import alertify from 'shared/alertify';

export default class extends Controller {
  static outlets = ['modal'];

  static values = { url: String };

  // action="modal-content-loader#load"
  async load() {
    const content = this.modalOutlet.element.querySelector('.modal-content');
    // 取得より先に開くので、前に開いたアプリの内容を消しておく
    content.replaceChildren();
    this.modalOutlet.open();

    try {
      const response = await fetch(this.urlValue, {
        headers: { Accept: 'text/html' },
      });
      if (!response.ok) throw new Error(response.statusText);
      content.innerHTML = await response.text();
    } catch (error) {
      console.error(error);
      alertify.error('エラーが発生しました。時間をおいて再度お試しください。');
    }
  }
}
